import DetailsCardIconComponent from './DetailsCardIconComponent';
export default DetailsCardIconComponent;
